module.exports = __webpack_public_path__ + "img/home1_yinliu_logo2.a4b43794.png";